import { EditIcon, HintCard, Inline, ObjectIcon, PlacementIcon, styled } from 'canoe';
import React from 'react';

import { useToolboxTab } from 'craft/state';

const InlineIcon = styled.div`
  padding-top: 4px;
  margin-bottom: -4px;
`;

export const Placeholder = () => {
  const { forcePlacementsTab } = useToolboxTab();

  if (forcePlacementsTab) {
    return (
      <div data-cy="editor-empty-state-placeholder">
        <HintCard
          marginTop="xxl"
          marginBottom="xxl"
          orderedList
          tips={[
            <Inline space="xxs">
              Finish placing content
              <InlineIcon>
                <PlacementIcon size="s" color="BerryBlueD10" />
              </InlineIcon>{' '}
              using the panel on the right.
            </Inline>,
            "Click 'Start Editing Content'.",
            'You’ll be able to change the Overlay position & size later.',
          ]}
        />
      </div>
    );
  }

  return (
    <div data-cy="editor-empty-state-placeholder">
      <HintCard
        marginTop="xxl"
        marginBottom="xxl"
        orderedList
        variant="primary"
        tips={[
          <Inline space="xxs">
            Drag Components{' '}
            <InlineIcon>
              <ObjectIcon size="s" color="BrandPurpleD10" />
            </InlineIcon>{' '}
            in from the toolbox on the left.
          </Inline>,
          <Inline space="xxs">
            Customise Components using the panel on the right{' '}
            <InlineIcon>
              <EditIcon size="s" color="BrandPurpleD10" />
            </InlineIcon>
          </Inline>,
        ]}
      />
    </div>
  );
};
